import { Action, State, StateContext, Store } from "@ngxs/store";
import { Step } from "../../models/Step";
import { Department, Role } from "../../models/insight-configuration.model";
import { EWB_CREATE_COMPONENTS, THRESHOLD_SYMBOL, UOM_MEASUREMENT_TYPE } from "../../enums/ewbConfiguration.enum";
import { Injectable } from "@angular/core";
import { InsightConfigurationService } from "../../services/insight-configuration.service";
import { UnitOfMeasureService } from "../../services/unit-of-measure/unit-of-measure.service";
import { CheckConfigurationUpdated,  ClearEwbConfigState,  GetAlgorithmAssetList, GetAlgorithmList, GetDepartments, GetKpiList, GetModels, GetEwbConfigurationDetails, GetRoleIds, GetRolesByDepartment, GetRolesByPlant, GetSubTypes, GetThemes, GetVersionsList, MoveStep, RemoveConfiguredAssets, RemoveSelectedAsset, RemoveSelectedImpactedKPI, SetAlgoLoading, SetAssetsDuplicateDetected, SetEwbMode, SetSelectedAlgorithm, SetSelectedAssetList, SetSelectedConfiguration, SetSelectedImpactedKPIs, SetThresholdUomConfig, SubmitEwbConfiguration, UpdateConfiguraitonDetails, UpdateStepValidity, SetSelectedVersion, GetInputId, GetJwtToken, GetEWBTimeseries } from "./ewb-configuration.action";
import { map, tap } from "rxjs";
import { patch, removeItem, updateItem } from "@ngxs/store/operators";
import { CONFIG_MODE } from "../../enums/insightConfigurations.enum";
import _ from "lodash";
import { UnitOfMeasure } from "../../models/UnitOfMeasure";
import { AlgorithmList, ModelList, VersionList } from "../../models/ewb.model";


/* istanbul ignore file */
export class EWBStateModel {
  versionsList :VersionList[];
  algorithmList: AlgorithmList[];
  modelList:ModelList[];
  inputId:string;
  token:string;
  assetSelection: any[];
  impactedKpiSelection: any [];
  selectedPlant: any;
  selectedAlgorithm: any;
  selectedVersion:any;
  assetsSelected: any[];
  configurationDetails: any;
  impactedKpiSelected: any [];
  configUid: string;
  isAlgoLoading: boolean;
  roleIdsByPlant: any[];
  roleListByPlant: any[];
  departmentList: Department[];
  roleList: Role[]
  subTypeList: any [];
  themeList: any [];
  modelId: string;
  mode: number;
  steps: Step[];
  activeStep: number;
  assetsDuplicateDetected: boolean;
  configurationUpdated: boolean;
  configurationDetailsSaved: any;
  impactedKpisSaved: any[];
  thresholdUomConfig: any;
  timeseries: any[];
}

@State<EWBStateModel>({
  name: 'ewb',
  defaults: {
    versionsList:[],
    algorithmList: [],
    modelList:[],
    inputId:'',
    assetSelection: [],
    impactedKpiSelection: [],
    token:null,
    selectedPlant: null,
    selectedAlgorithm: null,
    selectedVersion:null,
    assetsSelected: [],
    configurationDetails: {},
    impactedKpiSelected: [],
    configUid: null,
    isAlgoLoading: true,

    roleIdsByPlant: [],
    roleListByPlant: [],
    departmentList: [],
    roleList: [],
    subTypeList: [],
    themeList: [],
    modelId: null,

    mode: null,
    steps: [
      {
        stepIndex: EWB_CREATE_COMPONENTS.ALGORITHM,
        valid: false,
        stepName: 'algorithm'
      },
      {
        stepIndex: EWB_CREATE_COMPONENTS.ASSETS,
        valid: false,
        stepName: 'assetSelection'
      },
      {
        stepIndex: EWB_CREATE_COMPONENTS.CONFIGURATIONS,
        valid: false,
        stepName: 'configurations'
      },
      {
        stepIndex: EWB_CREATE_COMPONENTS.IMPACTED_KPIS,
        valid: false,
        stepName: 'impactedKPIs'
      },
    ],
    activeStep: 0,
    assetsDuplicateDetected: false,
    configurationUpdated:false,
    configurationDetailsSaved: {},
    impactedKpisSaved: [],
    thresholdUomConfig: null,
    timeseries: []
  }
})
@Injectable()
export class EwbConfigurationState {

  constructor(
    public insightConfigurationService: InsightConfigurationService,
    public uomService: UnitOfMeasureService,
    private readonly store: Store
  ) {}

  // Action for clearing the selected values during creation,
  // To be called every start of config creation process
  @Action(ClearEwbConfigState)
  clearState(ctx: StateContext<EWBStateModel>) {
    const state = ctx.getState();
    const steps = state.steps;
    steps.forEach(step => {step.valid = false})
    ctx.patchState({
      selectedAlgorithm: null,
      assetsSelected: [],
      configurationDetails: {},
      impactedKpiSelected: [],
      modelId: null,

      algorithmList: [],
      versionsList:[],
      assetSelection: [],
      impactedKpiSelection: [],
      configUid: null,

      //activeStep: 0,
      steps: [...steps],

      assetsDuplicateDetected: false,
      configurationDetailsSaved: {},
      impactedKpisSaved: []
    })
  }

  @Action(SetSelectedAlgorithm, {cancelUncompleted: true})
  setSelectedAlgorithm(ctx: StateContext<EWBStateModel>, {algorithm}: SetSelectedAlgorithm) {
    ctx.patchState({
      selectedAlgorithm: algorithm
    })
  }

  @Action(SetSelectedVersion, {cancelUncompleted: true})
  setSelectedVersion(ctx: StateContext<EWBStateModel>, {version}: SetSelectedVersion) {
    ctx.patchState({
      selectedVersion: version
    })
  }

  
  @Action(GetModels, {cancelUncompleted: true})
  getAlgorithmList(
    ctx: StateContext<EWBStateModel>
  ) {
    return this.insightConfigurationService.getModels().pipe(
      tap(response => {
        ctx.patchState({
          algorithmList: [...response]
        })
      })
    );
  }
  
    @Action(GetVersionsList, {cancelUncompleted: true})
  getVersionsList(
    ctx: StateContext<EWBStateModel>,
     {modelId}: GetVersionsList
  ) {
    return this.insightConfigurationService.getVersionList(modelId).pipe(
      tap(response => {
        ctx.patchState({
          versionsList: [...response]
        })
      })
    );
  }


   @Action(GetJwtToken, {cancelUncompleted: true})
  getJwtToken(
    ctx: StateContext<EWBStateModel>
  ) {
    const userName=localStorage.getItem('userName')
    return this.insightConfigurationService.getJwtToken(userName).pipe(
      tap(token => {
        ctx.patchState({
          token: token
        })
      })
    );
  }


  @Action(GetRoleIds, {cancelUncompleted: true})
  getRoleIds(
    ctx: StateContext<EWBStateModel>
  ) {
    const plant = this.store.selectSnapshot(state => state.configurations.selectedPlant);
    return this.insightConfigurationService.getRoleIds(plant.plantId).pipe(
      tap(roleIds => {
        ctx.patchState({
          roleIdsByPlant: [...roleIds]
        })
      })
    );
  }

  @Action(GetInputId,{cancelUncompleted: true})
  getInputId(
    ctx: StateContext<EWBStateModel>,
     {versionId}: GetInputId
  ) {
    return this.insightConfigurationService.getInputIdList(versionId).pipe(
      tap(inputList => {
        ctx.patchState({
          inputId: inputList
        })
      })
    );
  }

  

  @Action(GetRolesByPlant, {cancelUncompleted: true})
  getRolesByPlant(
    ctx: StateContext<EWBStateModel>,
    {roleIdList}: GetRolesByPlant
  ) {
    return this.insightConfigurationService.getRolesByPlant(roleIdList).pipe(
      tap(rolesByPlant => {
        let newRolesByPlant = rolesByPlant.map(role => {
          let newRoles = {
            roleId: role['RoleId'],
            roleName: role['RoleName']
          }
          return newRoles;
        })
        ctx.patchState({
          roleListByPlant: [...newRolesByPlant]
        })
      })
    );
  }

  @Action(GetDepartments, { cancelUncompleted: true })
  getDepartments(
    ctx: StateContext<EWBStateModel>
  ) {
    return this.insightConfigurationService.getDepartments().pipe(
      tap(departments => {
        let newDeparments = departments.map(department => {
          let newDept = {
            departmentId: department.departmentId ? department.departmentId : department['DepartmentId'],
            departmentName: department.departmentName ? department.departmentName : department['DepartmentName']
          }
          return newDept;
        })
        ctx.patchState({
          departmentList: [...newDeparments]
        })
      })
    );
  }

  @Action(GetRolesByDepartment, { cancelUncompleted: true })
  getRoles(
    ctx: StateContext<EWBStateModel>,
    {departmentId}: GetRolesByDepartment
  ) {
    return this.insightConfigurationService.getRolesByDepartment(departmentId).pipe(
      tap(roles => {
        if(roles && roles.length > 0) {
          let newRoles = roles.map(role => {
            let newRole = {
              roleId : role.roleId ? role.roleId : role['RoleId'],
              roleName : role.roleName ? role.roleName : role['RoleName']
            }
            return newRole;
          })

          ctx.patchState({
            roleList: [...newRoles]
          })
        } else {
          ctx.patchState({
            roleList: []
          })
        }
      })
    );
  }

  @Action(GetThemes, {cancelUncompleted: true})
  getThemes(
    ctx: StateContext<EWBStateModel>,
    {configurationId}: GetThemes
  ) {
    return this.insightConfigurationService.getThemes(configurationId).pipe(
      tap(themes => {
        ctx.patchState({
          themeList: [...themes]
        })
      })
    );
  }
@Action(GetAlgorithmList, {cancelUncompleted: true})
    GetEwbModels(
      ctx: StateContext<EWBStateModel>,
      {configurationId}: GetAlgorithmList
    ) {
      ctx.dispatch(new SetAlgoLoading(true));
      configurationId ??= this.store.selectSnapshot(state => state.configurations.selectedConfigType.viewId);
      return this.insightConfigurationService.getAlgorithmList(configurationId).pipe(
        tap(algorithm => {
          ctx.patchState({
            modelList: [...algorithm]
          })
        })
      );
    }
   
  @Action(GetSubTypes ,{cancelUncompleted: true})
  getSubTypes(ctx: StateContext<EWBStateModel>, {themeId, configurationId}: GetSubTypes) {
    return this.insightConfigurationService.getSubTypes(themeId, configurationId).pipe(
      tap(subTypes => {
        ctx.patchState({
          subTypeList: [...subTypes]
        })
      })
    )
  }

  @Action(GetAlgorithmAssetList, {cancelUncompleted: true})
  getAlgorithmAssetList(ctx: StateContext<EWBStateModel>, {modelList, refreshList}: GetAlgorithmAssetList) {
    const state = ctx.getState();
    let plant = this.store.selectSnapshot(state => state.configurations.selectedPlant);
    let categoryId = this.store.selectSnapshot(state => state.configurations.selectedConfigType.viewId);
    let modelId=modelList[0]['modelId'];
    

    return this.insightConfigurationService.getAssetList( modelId , plant?.plantId, categoryId)
    .pipe(
        tap((assetList: any) => {
          const newAssetList = assetList.map(asset => {
            asset.selected = false
            return asset;
          })

          if(refreshList) {
            // Called when refreshList is true
            // Update the selected asssets if configured or not with the newly fetched asset values
            const selectedAssets = state.assetsSelected;
            selectedAssets.forEach(selectedAsset => {
              let assetFound = newAssetList.find(asset => asset.assetId === selectedAsset.assetId);
              selectedAsset.configured = assetFound ? assetFound.configured : false;
            })

            // Update the state value
            ctx.patchState({
              assetsSelected: selectedAssets
            })
          }


          ctx.patchState({
              assetSelection: [...newAssetList]
          })

        })
    )
  }

  @Action(SetSelectedAssetList, {cancelUncompleted: true})
  setSelectedAssetList(ctx: StateContext<EWBStateModel>, {selectedAssets}: SetSelectedAssetList) {
    ctx.patchState({
      assetsSelected: selectedAssets
    })
  }

  @Action(RemoveSelectedAsset, {cancelUncompleted: true})
  removeSelectedAsset(ctx: StateContext<EWBStateModel>, {selectedAsset}: RemoveSelectedAsset) {

    ctx.setState(
      patch({
        assetsSelected : removeItem<any>(asset => asset.assetId === selectedAsset.assetId ),
        assetSelection: updateItem<any> (asset => asset.assetId === selectedAsset.assetId, patch({selected: false}) )
      })
    )

    // Check assets duplicates
    if(ctx.getState().assetsDuplicateDetected) {
      // If tagged as assets has duplicate
      // Recheck if after removing a  selected asset the assets selected don't have configured values
      const assetsSelected = ctx.getState().assetsSelected;
      const configuredCount = assetsSelected.filter(asset => asset.configured).length;
      if(configuredCount > 0) {
        // if having configured values on selected set to true
        this.store.dispatch(new SetAssetsDuplicateDetected(true))
      } else {
        // if NOT having configured values, set asset duplicate flag to false
        this.store.dispatch(new SetAssetsDuplicateDetected(false))
        if(assetsSelected.length > 0) {
          // Set validity to true when there assets seleccted
          this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.ASSETS, true))
        }
      }
    }
  }

  @Action(GetKpiList, {cancelUncompleted: true})
  getKpiList(ctx: StateContext<EWBStateModel>, {plantId}: GetKpiList) {

    return this.insightConfigurationService.getKpiList(plantId)
    .pipe(
      tap((kpiList: any) => {
        if(Array.isArray(kpiList)){
          const newKpiList = kpiList.map(kpi => {
            kpi.selected = false;
            kpi.externalid = kpi.configId;
            return kpi;
          })
          ctx.patchState({
            impactedKpiSelection: [...newKpiList]
          })
        }else{
          ctx.patchState({
            impactedKpiSelection: []
          })
        }
      })
    )
  }

  @Action(SetSelectedImpactedKPIs, {cancelUncompleted: true})
  setSelectedKPIs(ctx: StateContext<EWBStateModel>, {impactedKPIs}: SetSelectedImpactedKPIs) {
    ctx.patchState({
      impactedKpiSelected: impactedKPIs
    })
    ctx.dispatch(new CheckConfigurationUpdated());
  }

  @Action(RemoveSelectedImpactedKPI)
  removeSelectedKPI(ctx: StateContext<EWBStateModel>,{impactedKPI}: RemoveSelectedImpactedKPI) {
    ctx.setState(
      patch({
        impactedKpiSelected : removeItem<any>(kpi => kpi.uid === impactedKPI.uid ),
        impactedKpiSelection: updateItem<any> (kpi => kpi.uid === impactedKPI.uid, patch({selected: false}) )
      })
    )
    ctx.dispatch(new CheckConfigurationUpdated());
  }

  @Action(SubmitEwbConfiguration, {cancelUncompleted: true})
    submitEwbConfiguration(ctx: StateContext<EWBStateModel>) {

      const state = ctx.getState();
      const plant = this.store.selectSnapshot(state => state.configurations.selectedPlant);
      const configType = this.store.selectSnapshot(state => state.configurations.selectedConfigType);
      const algorithm = state.modelList;
      const timeseries = state.timeseries;
      const user_id = localStorage.getItem('userName');
      const package_version_id = state.selectedVersion['id'];
      const package_exec_id={};
      const inputs_id=state.inputId;

      const assets = state.assetsSelected.map((asset) => {
        delete asset.selected;
        delete asset.configured;
        delete asset.plantId;
        delete asset.plantName;
        return asset;
      });
      let {standardUom, displayUom} = this.getDisplayAndStandardUom(state.thresholdUomConfig.type)
      let thresholdValueInStandard = (state.thresholdUomConfig.type === UOM_MEASUREMENT_TYPE.PERCENTAGE) ? (state.configurationDetails.thresholdValue / 100): this.transformThreshold(displayUom, standardUom, state.configurationDetails.thresholdValue)

      const details = {...state.configurationDetails,
        priority: state.configurationDetails.priority.toUpperCase(),
        type: configType.type,
        template: configType.template,
        threshold: {value: thresholdValueInStandard, condition: THRESHOLD_SYMBOL[state.configurationDetails.thresholdCondition], config: configType.thresholdUomConfig},
        frequency: {value: parseInt(state.configurationDetails.frequencyValue), unit: state.configurationDetails.frequencyUnit},
        category: configType.category
      }

      delete details.thresholdValue;
      delete details.thresholdCondition;
      delete details.frequencyValue;
      delete details.frequencyUnit;
      delete details.actionIn['dataToShow']

      const impactedKpis = state.impactedKpiSelected.map((kpi) => {
        delete kpi.selected
        return kpi;
      })


      ctx.patchState({
        selectedPlant: null,
      })
      return this.insightConfigurationService.submitEWBConfiguration(plant, user_id, package_version_id, package_exec_id,inputs_id, configType, algorithm, assets, details, impactedKpis, timeseries)
      .pipe(
        map((data : any) => {

          if(data?.error) {
            // Throw error object as error
            throw data.error;
          } else if(data?.insightConfiguration){
            // throw null to display failing view
            ctx.dispatch(new ClearEwbConfigState());
          } else {
            ctx.dispatch(new ClearEwbConfigState());
            throw new Error();
          }
        })
      )
  }

  @Action(SetSelectedConfiguration, {cancelUncompleted: true})
  SetSelectedConfiguration(ctx: StateContext<EWBStateModel>, {configuration}: SetSelectedConfiguration) {
    const state = ctx.getState();
    const details = {...configuration,
      priority: configuration.priority?.toUpperCase(),
      template: state.configurationDetailsSaved.template,
      type: state.configurationDetailsSaved.type,
      category: state.configurationDetailsSaved.category,
      frequencyValue: Number(configuration.frequencyValue),    
    };
    

    ctx.patchState({
      configurationDetails: details
    })

    ctx.dispatch(new CheckConfigurationUpdated());
  }



  @Action(MoveStep)
  moveStep(ctx: StateContext<EWBStateModel>, {moveToStepIndex}: MoveStep) {
    ctx.patchState({
      activeStep: moveToStepIndex
    })
  }


  @Action(UpdateStepValidity)
  updateStepValidity(ctx: StateContext<EWBStateModel>, {stepIndex , validity}: UpdateStepValidity){
    ctx.setState(
      patch({
        steps: updateItem<any>(step => step.stepIndex === stepIndex, patch({valid: validity}))
      })
    )
  }

  @Action(SetAssetsDuplicateDetected)
  setAssetsDuplicatedDetected(ctx: StateContext<EWBStateModel>, {duplicate}: SetAssetsDuplicateDetected) {
    ctx.patchState({
      assetsDuplicateDetected: duplicate
    })
  }

  @Action(RemoveConfiguredAssets)
  removeConfiguredAssets(ctx: StateContext<EWBStateModel>) {
    let state = ctx.getState();
    const assetsSelected = state.assetsSelected;

    const newAssetsSelected =  assetsSelected.filter(asset => !asset.configured)

    // Update assets selected and set asset duplicate flag to false
    ctx.patchState({
      assetsSelected: newAssetsSelected,
      assetsDuplicateDetected: false
    })
  }

  @Action(SetEwbMode)
  setMode( ctx: StateContext<EWBStateModel>, {mode}: SetEwbMode) {
    ctx.patchState({
      mode: mode
    })
  }

  @Action(GetEwbConfigurationDetails)
  getEwbConfigurationDetails(ctx: StateContext<EWBStateModel>, {configId} :GetEwbConfigurationDetails) {
    return this.insightConfigurationService.getConfigurationDetails(configId)
    .pipe(
      map((data: any) => {
        if(data?.configuration[0]) {
          //Prepare values to be saved as reference for possible updates.
          let configuration = data?.configuration[0];
          let selectedPlantId = this.store.selectSnapshot(state => state.configurations.selectedPlant.plantId);
          let insightCategoryParameters = configuration.insightCategoryParameters;
          let condition = insightCategoryParameters.conditions[0];
          let id=insightCategoryParameters.algorithm.modelId;
          let package_version_id= insightCategoryParameters.package_version_id;
          const assetList = insightCategoryParameters.assetList.map(asset => {
            asset.selected = true;
            asset.configured = true;
            return asset;
          })
          const impactedKpis = insightCategoryParameters.impactedKpis.map(kpi => {
            kpi.selected = true;
            return kpi
          })

          ctx.dispatch(new SetThresholdUomConfig(condition.config))
          let {standardUom, displayUom} = this.getDisplayAndStandardUom(condition.config.type)

          let thresholdValue = 0;
          if(condition.config.type === UOM_MEASUREMENT_TYPE.PERCENTAGE ) {
            thresholdValue =  condition.value * 100;
          } else {
            thresholdValue = _.round(this.transformThreshold(standardUom, displayUom, condition.value), 3);
          }

          const details = { ...insightCategoryParameters,
            category: configuration.category,
            type: configuration.type,
            frequencyValue: insightCategoryParameters.schedule.value,
            frequencyUnit: insightCategoryParameters.schedule.unit,
            thresholdValue: thresholdValue,
            thresholdCondition: Object.keys(THRESHOLD_SYMBOL).find(key => THRESHOLD_SYMBOL[key] === condition.condition),
            categoryId: configuration.configurationCategory,
            theme: configuration.theme,
            subtype:configuration.subtype,
            department: configuration.department,
            role: configuration.role,
            actionIn: configuration.actionIn
          }

          //Calls all the API dependencies for populating field values
          ctx.dispatch(new GetDepartments());
          ctx.dispatch(new GetRolesByDepartment(configuration.department.departmentId));

          ctx.dispatch(new GetThemes(configuration.type));
          ctx.dispatch(new GetSubTypes(configuration.theme.id, configuration.configurationCategory));

          ctx.dispatch(new GetAlgorithmList(configuration.configurationCategory));
          ctx.dispatch(new GetVersionsList(id))
          ctx.dispatch(new GetInputId(package_version_id));
          ctx.dispatch(new GetKpiList(selectedPlantId));
          ctx.dispatch(new GetEWBTimeseries());

          ctx.patchState({
            configUid: data.uid,
            modelId: insightCategoryParameters.algorithm.modelId,
            selectedAlgorithm: insightCategoryParameters.algorithm,
            selectedVersion:insightCategoryParameters.version,
            assetsSelected: assetList,
            configurationDetails: {...details},
            impactedKpiSelected: impactedKpis,

            configurationDetailsSaved: _.cloneDeep({...details}),
            impactedKpisSaved: _.cloneDeep(impactedKpis),
            configurationUpdated: false
          })
        }
      })
    )
  }

  @Action(CheckConfigurationUpdated)
  setConfigurationUpdated(ctx: StateContext<EWBStateModel>) {
      // Evaluate if values are changed
      const state = ctx.getState();
      let updated = false;

      let selectedImpactedKpis = state.impactedKpiSelected.map(kpi => {
        delete kpi.computationTrigger
        delete kpi.configId
        delete kpi.plantName

        return kpi
      })

      let toEditConfiguration = {
        ...state.configurationDetails,
        impactedKpis: selectedImpactedKpis
      }

      let savedConfiguration = {
        ...state.configurationDetailsSaved,
        impactedKpis: state.impactedKpisSaved
      }
      let detailsEqual;

      if(state.mode === CONFIG_MODE.EDIT) {
       detailsEqual  = this.compareDetailsIfEqual(toEditConfiguration, savedConfiguration)
      }

      // Checks if the mode is edit
      // Checks if details was changed or impacted kpis selection was changed from previously saved values
      if(state.mode === CONFIG_MODE.EDIT && !detailsEqual) {
        updated = true;
      }

      ctx.patchState({
        configurationUpdated: updated
      })
  }

  compareDetailsIfEqual(details, savedDetails) {

    // Compares if saved details is still same with current details
    // returns true if still the same, else false
    const toCompareDetails = _.cloneDeep(details);
    savedDetails.impactedKpis = savedDetails.impactedKpis.map(kpi => kpi.uid);
    toCompareDetails.impactedKpis = toCompareDetails.impactedKpis.map(kpi => kpi.uid);
    delete toCompareDetails.actionIn['dataToShow'];

    const configDetails = {
      theme: toCompareDetails.theme,
      subtype: toCompareDetails.subtype,
      priority: toCompareDetails.priority,
      department: toCompareDetails.department,
      role: toCompareDetails.role,
      actionIn: toCompareDetails.actionIn,
      description: toCompareDetails.description,
      frequencyUnit: toCompareDetails.frequencyUnit,
      frequencyValue: toCompareDetails.frequencyValue,
      thresholdCondition: toCompareDetails.thresholdCondition,
      thresholdValue: toCompareDetails.thresholdValue,
      impactedKpis: toCompareDetails.impactedKpis
    }

    const savedConfigDetails = {
      theme: savedDetails.theme,
      subtype: savedDetails.subtype,
      priority: savedDetails.priority,
      department: savedDetails.department,
      role: savedDetails.role,
      actionIn: savedDetails.actionIn,
      description: savedDetails.description,
      frequencyUnit: savedDetails.frequencyUnit,
      frequencyValue: savedDetails.frequencyValue,
      thresholdCondition: savedDetails.thresholdCondition,
      thresholdValue: savedDetails.thresholdValue,
      impactedKpis: savedDetails.impactedKpis
    }
    return _.isEqual(configDetails, savedConfigDetails);
  }

  @Action(UpdateConfiguraitonDetails)
  updateConfigurationDetails (ctx: StateContext<EWBStateModel>){
    const state = ctx.getState();
    const plant = this.store.selectSnapshot(state => state.configurations.selectedPlant);
    const algorithm =state.configurationDetailsSaved.algorithm;
    const timeseries = state.timeseries;
    const user_id = localStorage.getItem('userName');
    const package_version_id = state.configurationDetailsSaved.package_version_id;
    const package_exec_id={};
    const inputs_id=state.configurationDetailsSaved.inputs_id;
    const assets = state.assetsSelected.map(asset => {
        delete asset.selected;
        delete asset.configured;
        return asset;
    });

    let {standardUom, displayUom} = this.getDisplayAndStandardUom(state.thresholdUomConfig.type)
    let thresholdValue = (state.thresholdUomConfig.type === UOM_MEASUREMENT_TYPE.PERCENTAGE) ?  (state.configurationDetails.thresholdValue / 100) : this.transformThreshold(displayUom, standardUom, state.configurationDetails.thresholdValue)

    // Prepare values saved in state to be passed to http request
    const configUid = state.configUid;
    const details = {...state.configurationDetails,
      priority: state.configurationDetails.priority.toUpperCase(),
      template: state.configurationDetailsSaved.template,
      type: state.configurationDetailsSaved.type,
      frequency: {unit: state.configurationDetails.frequencyUnit, value: state.configurationDetails.frequencyValue},
      threshold: {value: thresholdValue, condition: THRESHOLD_SYMBOL[state.configurationDetails.thresholdCondition], config: state.thresholdUomConfig},
      category: state.configurationDetailsSaved.category
    };

    delete details.frequencyUnit;
    delete details.frequencyValue;
    delete details.thresholdCondition;
    delete details.thresholdValue;
    delete details.actionIn.dataToShow;

    const impactedkpis = state.impactedKpiSelected.map(kpi =>
      {
        delete kpi.selected;
        return kpi
      })

    const category = {
      viewId: state.configurationDetailsSaved.categoryId
    }

    const updateDetails = {
      plant : plant,
      category : category,
      selectedAlgorithm : algorithm ,
      selectedAssets : assets,
      configurationDetails : details,
      selectedKpis : impactedkpis,
      timeseries : timeseries,
      user_id:user_id ,
      package_version_id:package_version_id,
      package_exec_id: package_exec_id,
      inputs_id:inputs_id
    }

    return this.insightConfigurationService.updateEWBConfiguration(configUid, updateDetails)
    .pipe(
      map((data: any) => {
        if(data?.insightConfiguration) {
          ctx.dispatch(new ClearEwbConfigState())
        } else {
          throw new Error();
        }
      })
    )
  }

  @Action(SetAlgoLoading)
  setAlgoLoading(ctx: StateContext<EWBStateModel>, {loading} : SetAlgoLoading) {
    ctx.patchState({
      isAlgoLoading: loading
    })
  }

  @Action(SetThresholdUomConfig)
  setThresholdUomConfig(ctx: StateContext<EWBStateModel>, {config}: SetThresholdUomConfig) {

    ctx.patchState({
      thresholdUomConfig: config
    })
  }

  @Action(GetEWBTimeseries, {cancelUncompleted: true})
  getTimeseries(
    ctx: StateContext<EWBStateModel>
  ) {
    let series = this.insightConfigurationService.getEWBtimeSeries()
    ctx.patchState({
      timeseries: [...series]
    })
  }

  public getDisplayAndStandardUom(type: string) {
    let standardUom = this.uomService.getUoMPerType(type, this.store.selectSnapshot(state => state.unitOfMeasure.standardUoMs));
    let displayUom = this.uomService.getUoMPerType(type, this.store.selectSnapshot(state => state.unitOfMeasure.userDefaultUoMs));
    if(!displayUom) { // check if display UoM exist if not use Standard
      displayUom = {...standardUom}
    }
    return {standardUom, displayUom};
  }

  public transformThreshold(fromUom: UnitOfMeasure, toUom: UnitOfMeasure, value: number) {
    let conversionFormula = this.uomService.getUoMConversionFormula(fromUom.UoMId, toUom.UoMId, this.store.selectSnapshot(state => state.unitOfMeasure.uomConversions));
    let thresholdValue = this.uomService.calculateUoM(value, conversionFormula);

    return thresholdValue
  }
}
